/**
 * One file per resource (plan §2). A new endpoint is a new file here plus one
 * line on `NookClient` — never an edit to `http.ts`.
 */
import { userSchema } from "@nook/schema";
export function getMe(http) {
    return http.request({ path: "/v1/me", schema: userSchema });
}
//# sourceMappingURL=me.js.map